module.exports = __webpack_public_path__ + "static/2-3705092e5f3ac42514df953f45359cfc.jpg";